import React from 'react';
import styled from 'styled-components';

const TermsService = ({ checkboxChecked, onCheckboxChange, isRegister }) => {
  
  const Container = styled('div')`
    color: ${checkboxChecked ? 'gray' : 'red'};
    font-size: 0.9rem;
    text-align: center;
    
    
    .blue-highlights {
      color: #007aff;
    }
    
  `;

  const handleCheckboxChange = () => {
    onCheckboxChange(!checkboxChecked);
  };

  return (
    <Container>
      <span style={{position: 'relative'}}>
        <input
          type="checkbox"
          style={{ marginBottom: '5px', opacity: 0, position: 'absolute' }}
          checked={checkboxChecked}
          onChange={handleCheckboxChange}
          
        />
        <span>
          {checkboxChecked ? (
            <span style={{ backgroundColor: '#F1F1F1', width: '17px', height: '18px', display: 'inline-block', border: '1px solid grey' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <path
                  d="M1 5L3.05 6.64C3.10506 6.68534 3.16952 6.71784 3.23872 6.73514C3.30791 6.75244 3.38009 6.7541 3.45 6.74C3.52058 6.72676 3.58749 6.69847 3.64616 6.65706C3.70483 6.61564 3.75389 6.56207 3.79 6.5L7 1"
                  stroke="#4FADA6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          ) : (
            <svg  style={{border: '1px solid grey'}} width="17" height="18" viewBox="0 0 17 18" fill="#F1F1F1" xmlns="http://www.w3.org/2000/svg">
              <rect width="17" height="18" fill="#F1F1F1" />
            </svg>
          )}
          <span />
        </span>
      </span>
    </Container>
  );
};

export default TermsService;
